export const accessControlRoutes = {
  manageGroupsHub: 'access-control/groups'
};
